import Vue from 'vue'
import debounce from 'lodash/debounce'

import footerRow from './pagination-footer-row'
Vue.component(footerRow.name, footerRow)

export default {
    slots() {
        return [
            {
                slot: "footer-row",
                component: footerRow.name
            }
        ]
    },
    mixins() {
        return {
            props: {
                displayPagination: {
                    type: Boolean,
                    default: true
                },
                pagination: {
                    type: [Object, Boolean],
                    default: false
                },
                paginationTotalRows: {
                    type: [Number, Boolean],
                    default: false
                }
            },
            data() {
                return {
                    conditionsState: {}
                }
            },
            methods: {
                goToPage( page, force = false ) {
                    if( this.$refs.footerRow.$refs.pagin === undefined ) {
                        return
                    }

                    this.$refs.footerRow.$refs.pagin.goToPage(page, force)
                },
                setPerPage( rowsPerPage ) {
                    if( this.$refs.footerRow.$refs.pagin === undefined ) {
                        return
                    }

                    this.$refs.footerRow.$refs.pagin.changeRowsPerPage(rowsPerPage)
                }
            },
            created() {
                Vue.set(this.conditionsState, 'pagination', {
                    page: 1,
                    rowsPerPage: this.pagination.rowsPerPage || require('@/helpers/Settings').default.rowsPerPage
                })

                let debounced_onChange = debounce(function(conditions) {
                    this.$emit('change', conditions)
                }.bind(this), 100)

                this.$off('change-internal').$on('change-internal', debounced_onChange)
            }
        }
    }
}
